<template>
  <div
    class="calendar-day-cell"
    :class="{
      'other-month': !day.isCurrentMonth,
      'selected': selected,
      'today': isToday,
      'has-collection': hasCollection
    }"
    @click="handleClick"
  >
    <div class="day-number">{{ day.dayNumber }}</div>
    <div v-if="hasCollection" class="waste-types">
      <div
        v-for="(wasteType, index) in day.wasteTypes"
        :key="index"
        class="waste-type-label"
      >
        {{ wasteType.typeName }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  day: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click'])

const isToday = computed(() => {
  const today = new Date()
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
  return props.day.date === todayStr
})

const hasCollection = computed(() => {
  return props.day.wasteTypes && props.day.wasteTypes.length > 0
})

const handleClick = () => {
  emit('click', props.day)
}
</script>

<style lang="scss" scoped>
.calendar-day-cell {
  border-right: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.5rem;
  min-height: 80px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;

  &:hover {
    background-color: #f5f5f5;
    transform: scale(1.02);
  }

  &.selected {
    border: 2px solid #dc3545;
    background-color: #fee2e2;
    z-index: 10;
  }

  &.other-month {
    background-color: #f9fafb;
    color: #9ca3af;

    .day-number {
      color: #d1d5db;
    }

    .waste-type-label {
      opacity: 0.5;
    }
  }

  &.today {
    background-color: #fff3cd;
    border: 2px solid #ffc107;

    .day-number {
      color: #856404;
      font-weight: bold;
    }
  }

  &.has-collection {
    background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
  }
}

.day-number {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  color: #374151;
}

.waste-types {
  font-size: 0.7rem;
  line-height: 1.3;
}

.waste-type-label {
  margin-bottom: 2px;
  padding: 1px 4px;
  background-color: #dbeafe;
  color: #1e40af;
  border-radius: 2px;
  display: inline-block;
  font-weight: 500;
  word-break: break-word;
  max-width: 100%;
}

@media (max-width: 768px) {
  .calendar-day-cell {
    min-height: 60px;
    padding: 0.25rem;
  }

  .day-number {
    font-size: 0.75rem;
  }

  .waste-types {
    font-size: 0.65rem;
  }

  .waste-type-label {
    padding: 0px 2px;
  }
}
</style>
